/** Run code **/
// import { createApp } from 'vue';
// import store from './app/store.js';
// import CookieBanner from './app/CookieBanner.vue';

// import Swiper JS
import Swiper, { Navigation, Pagination, Scrollbar, Autoplay } from 'swiper';
// import Swiper styles
import 'swiper/css';
// import smoothscroll for Smooth Scroll behavior on Safari
import smoothscroll from 'smoothscroll-polyfill';

// GSAP (GreenSock Animation Platform)
// import gsap from 'gsap';
// import ScrollTrigger from 'gsap/ScrollTrigger';

// gsap.registerPlugin(ScrollTrigger);
// window.gsap = gsap;

// const appEl = document.querySelector('#app');
// const app = createApp({});

// Install the store instance as a plugin
//app.use(store)

// Add vue components
// app.component('cookie-banner', CookieBanner);

// if (!!appEl) {
//   const mountedApp = app.mount(appEl);
// }

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Scrollbar, Autoplay]);

document.addEventListener('DOMContentLoaded', () => {
  // init fslightbox
  // require('fslightbox');
  // init smoothscroll
  smoothscroll.polyfill();

  const blockquotesSwiper = new Swiper('.blockquotes__items', {
    loop: true,
    slidesPerView: 1,
    navigation: {
      nextEl: '.blockquotes .button_next',
      prevEl: '.blockquotes .button_prev',
    },
    autoplay: {
      delay: 5000,
    },
  });

  // Custom progress bar and add header class on scroll

  window.addEventListener('scroll', progressBar);
  let header = document.querySelector('header');

  function progressBar() {
    let winScroll =
      document.body.scrollTop || document.documentElement.scrollTop;
    let height =
      document.documentElement.scrollHeight -
      document.documentElement.clientHeight;
    let scrolled = (winScroll / height) * 100;
    document.getElementById('progressBar').style.width = scrolled + '%';
    if (window.pageYOffset < 50 && header.classList.contains('scroll')) {
      header.classList.remove('scroll');
    }
    if (window.pageYOffset >= 50 && !header.classList.contains('scroll')) {
      header.classList.add('scroll');
    }
  }

  //Menu toggle

  const menuToggle = document.querySelector('.header__menu-toggle');
  const headerNav = document.querySelector('header nav');
  const menuLinks = document.querySelectorAll('header nav a');

  function navClick(e) {
    e.preventDefault();
    toggleMobileMenu();
    const sectionID = e.currentTarget.getAttribute('href');

    if (!document.body.classList.contains('home__page')) {
      window.location.href = '/' + sectionID;
    } else {
      const section = document.querySelector(sectionID);
      if (section) {
        const offset = section.offsetTop;
        window.scrollTo({
          top: offset,
          behavior: 'smooth',
        });
      }
    }
  }

  function toggleMobileMenu() {
    menuToggle.classList.toggle('open');
    headerNav.classList.toggle('open');
    document.body.classList.toggle('overflow-hidden-mobile');
  }

  if (menuToggle && headerNav) {
    menuToggle.addEventListener('click', toggleMobileMenu);
  }

  if (menuLinks.length) {
    menuLinks.forEach(el => {
      el.addEventListener('click', navClick);
    });
  }

  // Impressum & Datenschutz opening on click

  let privacyLink = document.querySelectorAll('.imprint');

  const openBlock = element => {
    let block = document.querySelector(element.getAttribute('href'));
    let menuHeight_compensetion =
      document.querySelectorAll('header')[0].clientHeight;

    if (!block.classList.contains('d-none')) {
      let anchorBlock = document.querySelector('footer');
      let elementPosition = anchorBlock.offsetTop;
      let offsetPosition =
        elementPosition +
        anchorBlock.clientHeight -
        document.documentElement.clientHeight;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
      setTimeout(() => {
        block.classList.add('d-none');
      }, 1000);
    } else {
      block.classList.remove('d-none');
      let anchorBlock = block;
      let headerOffset = menuHeight_compensetion;
      let elementPosition = anchorBlock.offsetTop;
      let offsetPosition = elementPosition - headerOffset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  };

  privacyLink.forEach((link, index) => {
    link.addEventListener('click', e => {
      e.preventDefault();
      openBlock(e.target);
    });
  });

  // Get current year for copyright text

  let date = new Date();
  let year = date.getFullYear().toString();
  // document.getElementById('year').innerText = year;

  //Countup.js

  var __assign =
    (this && this.__assign) ||
    function () {
      __assign =
        Object.assign ||
        function (t) {
          for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
              if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
          }
          return t;
        };
      return __assign.apply(this, arguments);
    };
  // playground: stackblitz.com/edit/countup-typescript
  var CountUp = /** @class */ (function () {
    function CountUp(target, endVal, options) {
      var _this = this;
      this.target = target;
      this.endVal = endVal;
      this.options = options;
      this.version = '2.0.8';
      this.defaults = {
        startVal: 0,
        decimalPlaces: 0,
        duration: 2,
        useEasing: true,
        useGrouping: true,
        smartEasingThreshold: 999,
        smartEasingAmount: 333,
        separator: ',',
        decimal: '.',
        prefix: '',
        suffix: '',
      };
      this.finalEndVal = null; // for smart easing
      this.useEasing = true;
      this.countDown = false;
      this.error = '';
      this.startVal = 0;
      this.paused = true;
      this.count = function (timestamp) {
        if (!_this.startTime) {
          _this.startTime = timestamp;
        }
        var progress = timestamp - _this.startTime;
        _this.remaining = _this.duration - progress;
        // to ease or not to ease
        if (_this.useEasing) {
          if (_this.countDown) {
            _this.frameVal =
              _this.startVal -
              _this.easingFn(
                progress,
                0,
                _this.startVal - _this.endVal,
                _this.duration,
              );
          } else {
            _this.frameVal = _this.easingFn(
              progress,
              _this.startVal,
              _this.endVal - _this.startVal,
              _this.duration,
            );
          }
        } else {
          if (_this.countDown) {
            _this.frameVal =
              _this.startVal -
              (_this.startVal - _this.endVal) * (progress / _this.duration);
          } else {
            _this.frameVal =
              _this.startVal +
              (_this.endVal - _this.startVal) * (progress / _this.duration);
          }
        }
        // don't go past endVal since progress can exceed duration in the last frame
        if (_this.countDown) {
          _this.frameVal =
            _this.frameVal < _this.endVal ? _this.endVal : _this.frameVal;
        } else {
          _this.frameVal =
            _this.frameVal > _this.endVal ? _this.endVal : _this.frameVal;
        }
        // decimal
        _this.frameVal = Number(
          _this.frameVal.toFixed(_this.options.decimalPlaces),
        );
        // format and print value
        _this.printValue(_this.frameVal);
        // whether to continue
        if (progress < _this.duration) {
          _this.rAF = requestAnimationFrame(_this.count);
        } else if (_this.finalEndVal !== null) {
          // smart easing
          _this.update(_this.finalEndVal);
        } else {
          if (_this.callback) {
            _this.callback();
          }
        }
      };
      // default format and easing functions
      this.formatNumber = function (num) {
        var neg = num < 0 ? '-' : '';
        var result, x1, x2, x3;
        result = Math.abs(num).toFixed(_this.options.decimalPlaces);
        result += '';
        var x = result.split('.');
        x1 = x[0];
        x2 = x.length > 1 ? _this.options.decimal + x[1] : '';
        if (_this.options.useGrouping) {
          x3 = '';
          for (var i = 0, len = x1.length; i < len; ++i) {
            if (i !== 0 && i % 3 === 0) {
              x3 = _this.options.separator + x3;
            }
            x3 = x1[len - i - 1] + x3;
          }
          x1 = x3;
        }
        // optional numeral substitution
        if (_this.options.numerals && _this.options.numerals.length) {
          x1 = x1.replace(/[0-9]/g, function (w) {
            return _this.options.numerals[+w];
          });
          x2 = x2.replace(/[0-9]/g, function (w) {
            return _this.options.numerals[+w];
          });
        }
        return neg + _this.options.prefix + x1 + x2 + _this.options.suffix;
      };
      this.easeOutExpo = function (t, b, c, d) {
        return (c * (-Math.pow(2, (-10 * t) / d) + 1) * 1024) / 1023 + b;
      };
      this.options = __assign(__assign({}, this.defaults), options);
      this.formattingFn = this.options.formattingFn
        ? this.options.formattingFn
        : this.formatNumber;
      this.easingFn = this.options.easingFn
        ? this.options.easingFn
        : this.easeOutExpo;
      this.startVal = this.validateValue(this.options.startVal);
      this.frameVal = this.startVal;
      this.endVal = this.validateValue(endVal);
      this.options.decimalPlaces = Math.max(0 || this.options.decimalPlaces);
      this.resetDuration();
      this.options.separator = String(this.options.separator);
      this.useEasing = this.options.useEasing;
      if (this.options.separator === '') {
        this.options.useGrouping = false;
      }
      this.el =
        typeof target === 'string' ? document.getElementById(target) : target;
      if (this.el) {
        this.printValue(this.startVal);
      } else {
        this.error = '[CountUp] target is null or undefined';
      }
    }

    // determines where easing starts and whether to count down or up
    CountUp.prototype.determineDirectionAndSmartEasing = function () {
      var end = this.finalEndVal ? this.finalEndVal : this.endVal;
      this.countDown = this.startVal > end;
      var animateAmount = end - this.startVal;
      if (Math.abs(animateAmount) > this.options.smartEasingThreshold) {
        this.finalEndVal = end;
        var up = this.countDown ? 1 : -1;
        this.endVal = end + up * this.options.smartEasingAmount;
        this.duration = this.duration / 2;
      } else {
        this.endVal = end;
        this.finalEndVal = null;
      }
      if (this.finalEndVal) {
        this.useEasing = false;
      } else {
        this.useEasing = this.options.useEasing;
      }
    };
    // start animation
    CountUp.prototype.start = function (callback) {
      if (this.error) {
        return;
      }
      this.callback = callback;
      if (this.duration > 0) {
        this.determineDirectionAndSmartEasing();
        this.paused = false;
        this.rAF = requestAnimationFrame(this.count);
      } else {
        this.printValue(this.endVal);
      }
    };
    // pause/resume animation
    CountUp.prototype.pauseResume = function () {
      if (!this.paused) {
        cancelAnimationFrame(this.rAF);
      } else {
        this.startTime = null;
        this.duration = this.remaining;
        this.startVal = this.frameVal;
        this.determineDirectionAndSmartEasing();
        this.rAF = requestAnimationFrame(this.count);
      }
      this.paused = !this.paused;
    };
    // reset to startVal so animation can be run again
    CountUp.prototype.reset = function () {
      cancelAnimationFrame(this.rAF);
      this.paused = true;
      this.resetDuration();
      this.startVal = this.validateValue(this.options.startVal);
      this.frameVal = this.startVal;
      this.printValue(this.startVal);
    };
    // pass a new endVal and start animation
    CountUp.prototype.update = function (newEndVal) {
      cancelAnimationFrame(this.rAF);
      this.startTime = null;
      this.endVal = this.validateValue(newEndVal);
      if (this.endVal === this.frameVal) {
        return;
      }
      this.startVal = this.frameVal;
      if (!this.finalEndVal) {
        this.resetDuration();
      }
      this.finalEndVal = null;
      this.determineDirectionAndSmartEasing();
      this.rAF = requestAnimationFrame(this.count);
    };
    CountUp.prototype.printValue = function (val) {
      var result = this.formattingFn(val);
      if (this.el.tagName === 'INPUT') {
        var input = this.el;
        input.value = result;
      } else if (this.el.tagName === 'text' || this.el.tagName === 'tspan') {
        this.el.textContent = result;
      } else {
        this.el.innerHTML = result;
      }
    };
    CountUp.prototype.ensureNumber = function (n) {
      return typeof n === 'number' && !isNaN(n);
    };
    CountUp.prototype.validateValue = function (value) {
      var newValue = Number(value);
      if (!this.ensureNumber(newValue)) {
        this.error = '[CountUp] invalid start or end value: ' + value;
        return null;
      } else {
        return newValue;
      }
    };
    CountUp.prototype.resetDuration = function () {
      this.startTime = null;
      this.duration = Number(this.options.duration) * 1000;
      this.remaining = this.duration;
    };
    return CountUp;
  })();

  // Counter options and init

  const options = {
    separator: '',
  };
  let first_number = new CountUp('firstCounter', 5, options);
  let second_number = new CountUp('secondCounter', 250, options);
  let third_number = new CountUp('thirdCounter', 42, options);
  let fourth_number = new CountUp('fourthCounter', 5400, options);
  const optionsObserver = {
    root: null,
    rootMargin: '0px',
    threshold: 0.2,
  };
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        first_number.start();
        second_number.start();
        third_number.start();
        fourth_number.start();
        observer.unobserve(whyUs);
      }
    });
  }, optionsObserver);
  let whyUs = document.querySelector('.why-us__facts');
  if (!!whyUs) {
    observer.observe(whyUs);
  }

  function initCompetenciesSlider() {
    const competenciesSliders = document.querySelectorAll('.competencies');

    if (!competenciesSliders.length) return;

    competenciesSliders.forEach(function (competenciesSlider) {
      const swiperContainer = competenciesSlider.querySelector('.cards-swiper');
      const prevButton = competenciesSlider.querySelector('.button_prev');
      const nextButton = competenciesSlider.querySelector('.button_next');

      if (!swiperContainer) return;

      let swiperInstance = null;

      function enableSwiper() {
        if (swiperInstance) return;

        let options = {
          centeredSlides: true,
          direction: 'horizontal',
          spaceBetween: 30,
          keyboard: true,
          a11y: true,
          grabCursor: true,
          slidesPerView: 1,
          parallax: true,
          speed: 800,
          loop: true,
          loopedSlides: 1,
          autoplay: {
            delay: 8000,
          },
        };

        if (prevButton && nextButton) {
          Swiper.use(Navigation);
          options.navigation = {
            prevEl: prevButton,
            nextEl: nextButton,
          };
        }

        swiperInstance = new Swiper(swiperContainer, options);
      }

      function disableSwiper() {
        if (!swiperInstance) return;
        swiperInstance.destroy(true, true);
        swiperInstance = null;
      }

      function checkViewport() {
        if (window.innerWidth <= 991) {
          enableSwiper();
        } else {
          disableSwiper();
        }
      }

      checkViewport();
      window.addEventListener('resize', checkViewport);
    });
  }

  initCompetenciesSlider();

  // FAQ Accordion functionality
  const faqQuestions = document.querySelectorAll('.faq__items .question');
  const faqArrowMobile = document.querySelectorAll(
    '.faq__items .answer .faq__icon',
  );

  faqQuestions.forEach(question => {
    question.addEventListener('click', function () {
      const faqItem = this.closest('.faq__item');
      const answer = faqItem.querySelector('.answer');
      const isOpen = faqItem.classList.contains('active');

      // Close all other FAQ items
      document.querySelectorAll('.faq__item').forEach(item => {
        if (item !== faqItem && item.classList.contains('active')) {
          item.classList.remove('active');
          const otherAnswer = item.querySelector('.answer');
          otherAnswer.style.maxHeight = null;
        }
      });

      // Toggle current FAQ item
      if (isOpen) {
        faqItem.classList.remove('active');
        answer.style.maxHeight = null;
      } else {
        faqItem.classList.add('active');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });

  faqArrowMobile.forEach(icon => {
    icon.addEventListener('click', function () {
      const faqItem = this.closest('.faq__item');
      const answer = faqItem.querySelector('.answer');

      faqItem.classList.remove('active');
      answer.style.maxHeight = null;
    });
  });

  document
    .querySelectorAll('.circle-background-hover-effect-wrapper')
    .forEach(wrapper => {
      const circle = wrapper.querySelector('.circle-background-hover-effect');

      wrapper.addEventListener('mousemove', e => {
        const rect = wrapper.getBoundingClientRect();

        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        requestAnimationFrame(() => {
          circle.style.left = `${x}px`;
          circle.style.top = `${y}px`;
        });
      });
    });

  function initFaqLoader() {
        const loadMoreBtn = document.getElementById('faq-load-more');
        const hiddenItems = document.querySelectorAll('.faq-hidden');

        if (!loadMoreBtn) {
            console.log("FAQ: Кнопка 'Mehr laden' не найдена");
            return;
        }

        loadMoreBtn.addEventListener('click', function() {
            console.log("FAQ: Нажата кнопка загрузки");
            
            hiddenItems.forEach(item => {
                item.style.display = 'block';
                setTimeout(() => {
                    item.style.opacity = '1';
                }, 10);
            });

            loadMoreBtn.closest('.faq__load-more-wrapper').style.display = 'none';
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initFaqLoader);
    } else {
        initFaqLoader();
    }
});
